import React, { useState, useEffect } from 'react';

const sliderImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200',
    title: 'State-of-the-Art Medical Facilities',
    description: 'Train with modern equipment and simulation labs',
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200',
    title: 'Expert Faculty & Mentorship',
    description: 'Learn from experienced healthcare professionals',
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200',
    title: 'Clinical Excellence',
    description: 'Hands-on training at partner hospitals',
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200',
    title: 'Research & Innovation',
    description: 'Contribute to healthcare advancements',
  },
];

const notificationsData = [
  { id: 1, date: 'Apr 10', title: 'Admissions Open 2026', type: 'urgent', icon: '📢' },
  { id: 2, date: 'Apr 8', title: 'Exam Schedule Released', type: 'info', icon: '📅' },
  { id: 3, date: 'Apr 5', title: 'New Simulation Lab', type: 'success', icon: '🏥' },
  { id: 4, date: 'Apr 1', title: 'Sports Meet Registration', type: 'info', icon: '🏆' },
];

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        {/* Left Side: Slider + Stats */}
        <div className="hero-main">
          {/* Slider */}
          <div className="slider-container">
            {sliderImages.map((slide, index) => (
              <div key={slide.id} className={`slider-slide ${index === currentSlide ? 'active' : ''}`}>
                <img src={slide.url} alt={slide.title} className="slider-image" />
                <div className="slider-content">
                  <span className="slider-badge">🌟 NAAC A++ Accredited</span>
                  <h2 className="slider-title">{slide.title}</h2>
                  <p className="slider-description">{slide.description}</p>
                  <div className="slider-buttons">
                    <button className="btn btn-primary">Apply Now</button>
                    <button className="btn btn-secondary">Virtual Tour</button>
                  </div>
                </div>
              </div>
            ))}
            
            <button className="slider-control prev" onClick={prevSlide}>‹</button>
            <button className="slider-control next" onClick={nextSlide}>›</button>
            
            <div className="slider-dots">
              {sliderImages.map((_, index) => (
                <button
                  key={index}
                  className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>

          {/* Stats Row (Below Slider) */}
          <div className="stats-row">
            <div className="stat-card">
              <span className="stat-icon">🎓</span>
              <span className="stat-value">5000+</span>
              <span className="stat-label">Graduates</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">💼</span>
              <span className="stat-value">98%</span>
              <span className="stat-label">Placement</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">👨‍🏫</span>
              <span className="stat-value">50+</span>
              <span className="stat-label">Faculty</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">🏆</span>
              <span className="stat-value">25+</span>
              <span className="stat-label">Years</span>
            </div>
          </div>
        </div>

        {/* Right Side: Notifications */}
        <div className="hero-sidebar">
          <div className="sidebar-header">
            <span className="sidebar-icon">🔔</span>
            <h3>Latest Updates</h3>
          </div>
          <div className="notifications-list">
            {notificationsData.map((notif) => (
              <div key={notif.id} className={`notification-item ${notif.type}`}>
                <div className="notification-icon">{notif.icon}</div>
                <div className="notification-content">
                  <span className="notification-date">{notif.date}</span>
                  <h4 className="notification-title">{notif.title}</h4>
                </div>
                <span className="notification-arrow">→</span>
              </div>
            ))}
          </div>
          <button className="view-all-btn">View All Notifications <span>→</span></button>
        </div>
      </div>
    </section>
  );
}

export default Hero;